
import {NavLink} from "react-router-dom";
export function  Header({selectbranchID}) {

    function  handleSlide(index) {
        var slide = document.querySelectorAll('.slide');
        for (let i = 0; i < slide.length; i++) {
            slide[i].classList.remove('is-expanded')
        }
        slide[index].classList.add('is-expanded')
    }

    return (    
        <div>
            <div className="app-sidebar__overlay" data-toggle="sidebar"></div>
            <aside className="app-sidebar sidebar-scroll">
                <div className="main-sidebar-header px-0 active">
                    <a className="desktop-logo active" href="">
                        <img src="/images/logo-2.png" className="main-logo mx-auto" alt="logo" />
                    </a>
                    <a className="logo-icon mobile-logo py-3 px-0 icon-light active" href="">
                        <img src="/images/logo.png" className="logo-icon mx-auto" alt="logo" />
                    </a>
                </div>
                <div className="main-sidemenu px-2 ">
                    <ul className="side-menu">
                        <li className="slide"  >
                            <a className="side-menu__item py-2 "  href="#">
                                <div className="side-menu_icon"><div className="side-menu__icon icon-home"></div></div>
                                <span className="side-menu__label"> หน้าหลัก</span>
                                <span className="tag tagnew">NEW</span>
                            </a>
                        </li>
                        <li>
                            <div className="break-menu fs-12 tc-1">เมนู</div>
                        </li>

                        <li className="slide " onClick={ (e) => {handleSlide(1)}} >
                            <a className="side-menu__item py-2" data-toggle="slide"  href="#">
                                <div className="side-menu_icon"><div className="side-menu__icon icon-business"></div></div>
                                <span className="side-menu__label">แพ็คเกจ</span>
                            </a>
                            <ul className="slide-menu">
                                <li><NavLink to="/packages" className="slide-item"   >จัดการแพ็คเกจ</NavLink></li>
                            </ul>
                        </li>
                        <li className="slide" onClick={ (e) => {handleSlide(2)}}>
                            <a className="side-menu__item py-2 "  href="#" data-toggle="slide">
                                <div className="side-menu_icon"><div className="side-menu__icon icon-note"></div></div>
                                <span className="side-menu__label">ลูกค้า</span>
                            </a>
                            <ul className="slide-menu">
                                <li><NavLink to="/customers" className="slide-item"   >รายชื่อลูกค้า</NavLink></li>
                            </ul>
                        </li>
            
        
                        <li>
                            <div className="break-menu fs-12 tc-1">ตั้งค่า</div>
                        </li>
                        <li className="slide" onClick={ (e) => {handleSlide(3)}}>
                            <a className="side-menu__item  py-2 "  href="#" data-toggle="slide">
                                <div className="side-menu_icon"><div className="side-menu__icon icon-setting"></div></div>
                                <span className="side-menu__label">ตั้งค่า</span>
                            </a>
                            <ul className="slide-menu">
                                <li>
                                    <NavLink to="/setting/users" className="slide-item"  >จัดการข้อมูลผู้ใช้งาน</NavLink>
                                </li>
                            </ul>
                        </li>


                    </ul>
                </div>
            </aside>
        </div>
    );
}